export const fmtEur = (n) => `${(Number(n) || 0).toLocaleString("it-IT", { minimumFractionDigits: 2, maximumFractionDigits: 2, useGrouping: "always" })} €`;
export const fmtData = (d) => (d ? d.split("-").reverse().join("/") : "");

export const MEZZI = {
  bonifico: { label: "Bonifico", cls: "bg-sky-100 text-sky-800" },
  bonifico_istantaneo: { label: "Bonifico istantaneo", cls: "bg-cyan-100 text-cyan-800" },
  assegno: { label: "Assegno", cls: "bg-violet-100 text-violet-800" },
  pos: { label: "Contactless/POS", cls: "bg-indigo-100 text-indigo-800" },
  sdd: { label: "Addebito diretto", cls: "bg-orange-100 text-orange-800" },
  f24: { label: "F24", cls: "bg-rose-100 text-rose-800" },
  prelievo: { label: "Prelievo", cls: "bg-stone-200 text-stone-800" },
  commissioni: { label: "Commissioni", cls: "bg-zinc-200 text-zinc-700" },
  altro: { label: "Altro", cls: "bg-slate-100 text-slate-700" },
};

export const STATI = {
  collegato: { label: "Collegato", cls: "bg-emerald-100 text-emerald-800" },
  automatico: { label: "Automatico", cls: "bg-teal-100 text-teal-800" },
  da_collegare: { label: "Da collegare", cls: "bg-amber-100 text-amber-800" },
  attesa_fattura: { label: "In attesa di fattura", cls: "bg-blue-100 text-blue-800" },
  senza_fattura: { label: "Senza fattura", cls: "bg-slate-200 text-slate-700" },
};

export const statoKey = (m) => (m.stato === "collegato" && m.automatico ? "automatico" : m.stato);
